import { render } from "./classesSlider.vue?vue&type=template&id=b42cc712"
import script from "./classesSlider.vue?vue&type=script&lang=js"
export * from "./classesSlider.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__